import { Field } from 'Util/Query';

/** @namespace Scandiweb/Flexibleforms/Query/FlexibleForms/Query */
export class FlexibleFormsQuery {
    getQuery() {
        return new Field('flexibleForms')
            .addField(this.getConfigField())
            .addField(this.getAllFormsData());
    }

    getFormQuery(form_id) {
        return new Field('flexibleForms')
            .addField(this.getConfigField())
            .addField(this.getForm(form_id)).addArgument('form_id', 'Int', form_id);
    }

    getConfigField() {
        return new Field('flexibleFormsConfig')
            .addFieldList(this.getConfigFields());
    }

    getConfigFields() {
        return [
            'enable',
            'enable_footer_link',
            'enable_breadcrumbs',
            'recaptcha_enabled',
            'enable_loggedin_users',
            'frontend_flexibleforms_title',
            'frontend_title',
            'form_url_prefix',
            'form_url_suffix',
            'redirect_url',
            'enable_store_result_database',
            'enable_to_admin',
            'admin_email_name',
            'admin_email_address',
            'admin_from_email_address',
            'admin_email_subject',
            'enable_to_customer',
            'customer_email_name',
            'customer_email_subject',
            'site_key',
            'secret_key'
        ];
    }

    getAllFormsData() {
        return new Field('getAllFormsData')
            .addFieldList(this.getAllFormsFields());
    }

    getAllFormsFields() {
        return [
            'form_id',
            'store_id',
            'form_title',
            'form_top_description',
            'form_bottom_description',
            'form_success_description',
            'form_fail_description',
            'form_button_text',
            'form_status',
            'total_fields',
            'enable_captcha',
            new Field('fields').addFieldList([
                'field_id',
                'fieldset_id',
                'field_title',
                'field_type',
                'field_style',
                'field_value',
                'field_tooltip',
                'field_note',
                'field_class',
                'field_layout',
                'field_options',
                'field_options_value',
                'field_position',
                'field_required',
                'field_custom_validation',
                'field_status'
            ])
        ];
    }

    getForm() {
        return new Field('getForm')
            .addFieldList(this.getFormFields());
    }

    getSelectOptionsField() {
        return new Field('field_options').addFieldList([
            'id',
            'value',
            'label',
            'parent_id',
            'allowed_car_manufacturer'
        ]);
    }

    getFormFields() {
        return [
            'form_id',
            'form_key',
            'store_id',
            'form_title',
            'form_top_description',
            'form_bottom_description',
            'form_success_description',
            'form_fail_description',
            'form_button_text',
            'form_status',
            'total_fields',
            'enable_captcha',
            new Field('field_sets').addFieldList([
                new Field('fields').addFieldList([
                    'field_id',
                    'fieldset_id',
                    'field_title',
                    'field_type',
                    'field_style',
                    'field_value',
                    'field_tooltip',
                    'field_note',
                    'field_class',
                    'field_layout',
                    'field_options_value',
                    'field_position',
                    'field_required',
                    'field_custom_validation',
                    'field_status'
                ]).addField(this.getSelectOptionsField()),
                'fieldset_id',
                'fieldset_description',
                'fieldset_title',
                'fieldset_status',
                'fieldset_class'
            ])
        ];
    }
}

export default new FlexibleFormsQuery();
